// https://github.com/chilts/node-ofx

import moment from "moment";
import { xml2json } from "xml-js";

function sgml2Xml(sgml) {
    return sgml
        .replace(/>\s+</g, '><')    // remove whitespace inbetween tag close/open
        .replace(/\s+</g, '<')      // remove whitespace before a close tag
        .replace(/>\s+/g, '>')      // remove whitespace after a close tag
        .replace(/<([A-Z0-9_]*)+\.+([A-Z0-9_]*)>([^<]+)/g, '<\$1\$2>\$3' )
        .replace(/<(\w+?)>([^<]+)/g, '<\$1>\$2</\$1>');
}

function parse(data) {
    // Split into the header attributes and the footer sgml
    const ofx = data.split('<OFX>', 2);

    const headerString = ofx[0].split(/\r?\n/);
    const header = {};
    headerString.forEach((attrs) => {
        const headAttr = attrs.split(/:/,2);
        header[headAttr[0]] = headAttr[1];
    });

    // make the SGML and the XML
    const content = `<OFX>${ofx[1]}`;

    // Parse the XML/SGML portion of the file into an object
    // Try as XML first, and if that fails do the SGML->XML mangling
    let dataParsed = null;
    try {
        dataParsed = JSON.parse((xml2json(content, { compact: true, spaces: 2 })));
    } catch (e) {
        dataParsed = JSON.parse((xml2json(sgml2Xml(content), { compact: true, spaces: 2 })));
    }

    dataParsed.header = header;

    return dataParsed;
}

function serialize(header, body) {
    let out = '';
    // header order could matter
    const headers = ['OFXHEADER', 'DATA', 'VERSION', 'SECURITY', 'ENCODING', 'CHARSET',
        'COMPRESSION', 'OLDFILEUID', 'NEWFILEUID'];

    headers.forEach((name) => {
        out += `${name}:${header[name]}\n`;
    });
    out += '\n';

    out += objToOfx({ OFX: body });
    return out;
}

function objToOfx(obj){
    let out = '';

    Object.keys(obj).forEach((name) => {
        const item = obj[name];
        const start = `<${name}>`;
        const end = `</${name}>`;

        if (item instanceof Object) {
            if (item instanceof Array) {
                item.forEach((it) => {
                    out += `${start}\n${objToOfx(it)}${end}\n`;
                });
                return;
            }
            return out += `${start}\n${objToOfx(item)}${end}\n`
        }
        out += start + item + '\n';
    });

    return out;
}

function formatBalanceDate(date, add = false) {
    const truncatedDate = date.substring(0,8)
    const formattedDate = moment(truncatedDate, "YYYYMMDD")
    if(add) {
        return formattedDate.add(-1, "days").format("YYYY-MM-DD");
    }
    return formattedDate.format("DD/MM/YYYY");
}

export function parseOFX(ofxData, fileName) {
    // debugger
    const data = parse(ofxData);

    // Sign-On Response 
    const SONRS = data.OFX.SIGNONMSGSRSV1.SONRS
    const signOnResponse = {
        stauts: {
            code: SONRS.STATUS?.CODE?._text,
            severity: SONRS.STATUS?.SEVERITY?._text,
        },
        dtServer: SONRS.DTSERVER?._text,
        language: SONRS.LANGUAGE?._text,
    }
    const financialInstitution = {
        id: SONRS.FI?.FID?._text,
        name: SONRS.FI?.ORG?._text
    }

    const arraySTMTTRNRS = Array.isArray(data.OFX.BANKMSGSRSV1.STMTTRNRS) 
    ? data.OFX.BANKMSGSRSV1.STMTTRNRS 
    : [data.OFX.BANKMSGSRSV1.STMTTRNRS];

    const statements = arraySTMTTRNRS.map(STMTTRNRS => {
        const bankAccount = {
            bank: { id: STMTTRNRS.STMTRS.BANKACCTFROM.BANKID._text },
            account: {
                id: STMTTRNRS.STMTRS.BANKACCTFROM.ACCTID._text,
                type: STMTTRNRS.STMTRS.BANKACCTFROM.ACCTTYPE._text,
            }
        };

        const currency = STMTTRNRS.STMTRS.CURDEF._text;

        const balance = {
            amount: parseFloat(STMTTRNRS.STMTRS.LEDGERBAL.BALAMT._text),
            date: formatBalanceDate(STMTTRNRS.STMTRS.LEDGERBAL.DTASOF._text, true)
        };

        const transactions = {
            transactionStartDate: STMTTRNRS.STMTRS.BANKTRANLIST.DTSTART._text,
            transactionEndDate: STMTTRNRS.STMTRS.BANKTRANLIST.DTEND._text,
            list: []
        };

        const arraySTMTTRN = Array.isArray(STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN)
            ? STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN
            : [STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN];

        transactions.list = arraySTMTTRN.length && arraySTMTTRN[1] // arraySTMTTRN not empty and no undefined items
            ? arraySTMTTRN.map(STMTTRN => {
            const trnType = STMTTRN.TRNTYPE._text.toLowerCase() ;
            const date = formatBalanceDate(STMTTRN.DTPOSTED._text);
            const wording = STMTTRN.NAME._text;
            const identifier = STMTTRN.FITID._text;
            const trnAmount = parseFloat(STMTTRN.TRNAMT._text);

            let type = trnType
            let amount = Math.abs(trnAmount).toString()
            if(!["debit","credit"].includes(trnType)) {
                type =  trnAmount > 0 ? "credit" : "debit"
            }
            
            return {[type]: amount, wording, date, identifier}
        }) : null

        return transactions.list ? { bankAccount, currency, balance, transactions } : null;

    }).filter(statement => statement !== null);

    // let items = statements.flatMap(stat => stat.transactions?.list)

    // const overallBalance = {
    //     balance: statements.reduce((sum, item) => sum + item.balance.amount, 0),
    //     balanceDate: statements.every(item => item.balance.date === statements[0].balance.date) ? statements[0].balance.date : ""
    // }

    // const bankTransaction = {
    //     importedItems: items,
    //     accDates: [],
    //     foundErrors: [],
    //     stream: ofxData,
    //     fileName: fileName,
    //     analysedData: overallBalance,
    //     positions: {
    //         amount: false,
    //         dateRealization: false,
    //         accountingDate: false,
    //     }
    // }

    const bankTransactions = statements.map(statement => {
        return {
            importedItems: statement.transactions.list,
            accDates: [],
            foundErrors: [],
            stream: ofxData,
            fileName: fileName,
            analysedData: {
                balance: statement.balance.amount,
                balanceDate: statement.balance.date
            },
            positions: {
                amount: false,
                dateRealization: false,
                accountingDate: false,
            }
        }
    })
    // console.log(data)
    return bankTransactions
}

export function serializeOFX(header, body) {
    // debugger
    const data = serialize(header, body);
    // console.log(data)
    return data
}
